import { render, staticRenderFns } from "./four.vue?vue&type=template&id=4c3f50cf&scoped=true"
import script from "./four.vue?vue&type=script&lang=js"
export * from "./four.vue?vue&type=script&lang=js"
import style0 from "./four.vue?vue&type=style&index=0&id=4c3f50cf&prod&lang=less"
import style1 from "./four.vue?vue&type=style&index=1&id=4c3f50cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3f50cf",
  null
  
)

export default component.exports